<template>
  <div class="styj">

    <Head v-bind:headTxt="headTxt"></Head>

    <YangBen v-bind:YangBenBox="YangBenBox"></YangBen>

    <ShiJi v-bind:shiJiBox="shiJiBox"></ShiJi>

    <RightBox v-bind:rightBox="rightBox"></RightBox>

    <div class="map_box">
      <Map v-bind:mapBut="mapBut"></Map>
    </div>

    <div class="l_box">
      <div class="box_1">
        <div class="bgc box_1_l">
          <div class="title">传统手工业</div>
          <div class="l_2_content">
            <div class="content_txt">
              <span class="txtc">{{cyxwList.b_Tradition_sum}}</span>
              <p>总数</p>
            </div>
            <div class="content_img">
              <div v-show="craft_img.length > 0">
                <el-carousel height="100%"
                             indicator-position="none">
                  <el-carousel-item v-for="(item,index) in craft_img"
                                    :key="index">
                    <el-image style="width:100%; height:100%"
                              :src="item"
                              fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-show="craft_img.length == 0">
                <span class="noTxt"
                      style="line-height:13.5vh;margin-left:23%">暂无调研图片</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bgc box_1_l"
             style="margin-left: 1%;">
          <div class="box_1_l_txt">
            <p>总计</p>
            <span class="txtc">{{(cyxwList.b_Income_one)+(cyxwList.b_Income_two)+(cyxwList.b_Income_three)}}</span>
            <p>一产：{{cyxwList.b_Income_one}}&nbsp;&nbsp;二产：{{cyxwList.b_Income_two}}&nbsp;&nbsp;三产：{{cyxwList.b_Income_three}}</p>
          </div>
          <div class="chart1"
               id="l_chart_shouru"></div>
        </div>
      </div>
      <div class="box_2">
        <div class="box_2_l">
          <div class="bgc t_box">
            <div class="box_2_l_txt">
              <!-- <ul>
                <li>有：23</li>
                <li>无：8</li>
                <li>总计：31</li>
              </ul> -->
              <p>总计</p>
              <span class="txtc">{{(cyxwList.b_Shop_be)+(cyxwList.b_Shop_without)}}</span>
              <p>有：{{cyxwList.b_Shop_be}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;无：{{cyxwList.b_Shop_without}}</p>
            </div>
            <div class="chart2"
                 id="l_chart_dianshang"></div>
          </div>
          <div class="bgc b_box">
            <div class="title">农商推荐</div>
            <div style="height: 23vh;">
              <!-- <DanMu v-bind:danMuBox="danMuBox1"></DanMu> -->
              <template>
                <el-table :data="noshangListDate"
                          height="100%"
                          table-layout='auto'
                          :show-header="false"
                          style="width: 100%">
                  <el-table-column label="农商推荐">
                    <template slot-scope="scope">
                      <!--渲染对应表格里面的内容-->
                      {{scope.row}}
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </div>
        </div>
        <div class="bgc box_2_r">
          <div class="title">地方特色商品</div>
          <div class="box_2_t">
            <!-- <DanMu v-bind:danMuBox="danMuBox2"></DanMu> -->
            <template>
              <el-table :data="teseListDate"
                        height="100%"
                        table-layout='auto'
                        :show-header="false"
                        style="width: 100%">
                <el-table-column label="农商推荐">
                  <template slot-scope="scope">
                    <!--渲染对应表格里面的内容-->
                    {{scope.row}}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
          <div class="box_2_b">
            <div v-show="feature_img.length > 0">
              <el-carousel height="100%"
                           indicator-position="none">
                <el-carousel-item v-for="(item,index) in feature_img"
                                  :key="index">
                  <el-image style="width:100%; height:100%"
                            :src="item"
                            fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="feature_img.length == 0">
              <span class="noTxt"
                    style="line-height:20vh;margin-left:30%">暂无调研图片</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import YangBen from '@/components/YangBen.vue'
import RightBox from '@/components/RightBox.vue'
import ShiJi from '@/components/ShiJi.vue'
import Map from '@/components/Map.vue'
import DanMu from '@/components/DanMu.vue'
import bus from '../utils/bus.js'

export default {
  components: {
    Head,
    YangBen,
    RightBox,
    ShiJi,
    Map,
    DanMu
  },
  data () {
    return {
      YangBenBox: {
        xian: '123',
        xiang: '12',
        cun: '1'
      },
      city_id: 0,
      cyxwList: {},
      shiJiBox: {
        shiJiTitle: '产业兴旺大事记',
        diDian: '湖南省',
        shiJiList: [
          '勾蓝瑶寨农村环境整治整体推进综合治理项目，自2018年6月开工建设以来，共投资60余万元，对全村进行集中整治。建设了农村饮用水项目、生活污水治理项目、生活垃圾收集系统、农村改厕改水和农村“五清五化”治理等。',
          '2022年8月，青年水库，水域面积750多亩，总库容600余万立方米，主要用于农业灌溉、城市生态补水、防洪排涝、景观用水等，提升青年水库水质，加强周边生态环境保护尤为重要。',
        ]
      },
      rightBox: {
        boxTitle: '湖南民族地区乡村产业简介',
        boxText: '湖南地形以山地丘陵为主，大陆性亚热带季风湿润气候。党的十八大以来,湖南深入践行习近平生态文明思想,牢记“守护好一江碧水”的殷殷嘱托,以前所未有的力度推进生态文明建设,全省生态环境发生了历史性、转折性、全局性变化。',
        images: [],
      },
      headTxt: '产业兴旺数据仓',
      mapBut: '湖南农业地图>>>',
      teseListDate: [],
      noshangListDate: [],
      craft_img: [],
      feature_img: [],

      // 主要收入来源
      shouRuChar: null,

      // 电商统计
      dianShangChar: null,

      blistNew: []
    }
  },
  mounted () {
    this.getDate()

    bus.$on('mapBus', (date) => {
      console.log(date, 'mapBushhhhhh')
      this.city_id = date.city_id
      this.getDate(date)
    })
  },
  methods: {
    getDate (date) {
      let newDate = "";
      if (date) {
        newDate = date.region;
      } else {
        newDate = "永州市";
      }

      console.log(this.city_id);
      var date = JSON.parse(localStorage.getItem("date"));
      date.forEach((item, index) => {
        if (item.region == newDate) {
          this.cyxwList = item;
        }
      });

      this.rightBox.images = []
      const introList = this.cyxwList.industry_intro.split('#')
      this.rightBox.boxText = introList[0]
      for (let i = 1; i < introList.length; i++)
      {
        this.rightBox.images.push(introList[i])
      }
      console.log(this.rightBox, '数据处理后');

      // 主要收入来源
      this.shouRuEcharts()
      // 电商统计
      this.dianShangEcharts()

      // 处理传统手工业图片
      this.craft_img = this.cyxwList.blist.map((item) => {
        return item.craft_img
      })
      for (var i = this.craft_img.length - 1; i >= 0; i--)
      {
        if (this.craft_img[i] == "" || this.craft_img[i] == null)
        {
          this.craft_img.splice(i, 1);
        }
      }
      if (this.craft_img.length > 0)
      {
        this.craft_img = this.craft_img.join('、')
        this.craft_img = this.craft_img.split('、')
      }
      console.log(this.craft_img);
      // 处理地方特色图片
      this.feature_img = this.cyxwList.blist.map((item) => {
        return item.feature_img
      })
      for (var i = this.feature_img.length - 1; i >= 0; i--)
      {
        if (this.feature_img[i] == "" || this.feature_img[i] == null)
        {
          this.feature_img.splice(i, 1);
        }
      }
      if (this.feature_img.length > 0)
      {
        this.feature_img = this.feature_img.join('、')
        this.feature_img = this.feature_img.split('、')
      }
      console.log(this.craft_img);

      // 处理表格数据
      this.teseListDate = this.cyxwList.blist.map((item) => {
        return item.feature_name
      })
      this.teseListDate = this.teseListDate.join('、')
      this.teseListDate = this.teseListDate.split('、')
      for (var i = this.teseListDate.length - 1; i >= 0; i--)
      {
        if (this.teseListDate[i] == "" || this.teseListDate[i] == null || this.teseListDate[i] == "无")
        {
          this.teseListDate.splice(i, 1);
        }
      }
      console.log(this.teseListDate, '表格数据1');

      this.noshangListDate = this.cyxwList.blist.map((item) => {
        return item.electronic_name
      })
      this.noshangListDate = this.noshangListDate.join('、')
      this.noshangListDate = this.noshangListDate.split('、')
      for (var i = this.noshangListDate.length - 1; i >= 0; i--)
      {
        if (this.noshangListDate[i] == "" || this.noshangListDate[i] == null || this.noshangListDate[i] == "无")
        {
          this.noshangListDate.splice(i, 1);
        }
      }
      console.log(this.noshangListDate, '表格数据2');

      // 处理大事记数据
      this.shiJiBox.shiJiList = this.cyxwList.blist.map((item) => {
        return item.event_date + '  |  ' + item.event_influence + '  |  ' + item.event_name
      })
      console.log(this.shiJiBox.shiJiList, 'hhhhhhhh');
      for (var i = this.shiJiBox.shiJiList.length - 1; i >= 0; i--)
      {
        if (this.shiJiBox.shiJiList[i] == "  |    |  " || this.shiJiBox.shiJiList[i] == "null  |  null  |  null" || this.shiJiBox.shiJiList[i] == "无  |  无  |  无")
        {
          this.shiJiBox.shiJiList.splice(i, 1);
        }
      }
      console.log(this.shiJiBox.shiJiList);
    },

    // 主要收入来源
    shouRuEcharts () {
      this.shouRuChar = this.$echarts.init(document.getElementById("l_chart_shouru"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.shouRuChar.resize()
      });
      var optoin = {
        title: {
          text: "主要收入来源",
          left: "3%",
          top: '2%',
          textStyle: {
            color: '#333',
            fontSize: this.$fontSize.fontSize(0.20)
          }
        },
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: false,
            radius: '90%',
            center: ["72%", "50%"],
            itemStyle: {
              borderRadius: 3,
              borderColor: '#666',
            },
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0)
                  {
                    return params.value + '\n' + params.name;
                  } else
                  {
                    return '';
                  }
                },
                position: 'inner',
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15,
                    align: "center"
                  },
                  b: {                        //name 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"

                  },
                  c: {                   //value 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"
                  }
                }
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: this.cyxwList.b_Income_one,
                itemStyle: {
                  color: '#CC99CC'
                },
                name: '一产'
              },
              {
                value: this.cyxwList.b_Income_two,
                itemStyle: {
                  color: '#FFCC99'
                },
                name: '二产'
              },
              {
                value: this.cyxwList.b_Income_three,
                itemStyle: {
                  color: '#FF6666'
                },
                name: '三产'
              }
            ]
          }
        ]
      }
      this.shouRuChar.setOption(optoin)
    },

    // 电商统计
    dianShangEcharts () {
      this.dianShangChar = this.$echarts.init(document.getElementById("l_chart_dianshang"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.dianShangChar.resize()
      });
      var optoin = {
        title: {
          text: "电商统计",
          left: "3%",
          top: '2%',
          textStyle: {
            color: '#333',
            fontSize: this.$fontSize.fontSize(0.20)
          }
        },
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: false,
            radius: '90%',
            center: ["70%", "50%"],
            itemStyle: {
              borderRadius: 3,
              borderColor: '#666',
            },
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0)
                  {
                    return params.value + '\n' + params.name;
                  } else
                  {
                    return '';
                  }
                },
                position: 'inner',
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15,
                    align: "center"
                  },
                  name: {                        //name 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"

                  },
                  c: {                   //value 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"
                  }
                }
              }
            },
            labelLine: {
              show: false
            },
            data: [
              {
                value: this.cyxwList.b_Shop_be,
                itemStyle: {
                  color: '#CC99CC'
                },
                name: '有'
              },
              {
                value: this.cyxwList.b_Shop_without,
                itemStyle: {
                  color: '#FFCC99'
                },
                name: '无'
              }
            ]
          }
        ]
      }
      this.dianShangChar.setOption(optoin)
    },

  }
}
</script>

<style lang="less" scoped>
.map_box {
  position: absolute;
  top: 7vh;
  left: 35%;
  width: 39%;
  height: 87vh;
}

.l_box {
  position: absolute;
  top: 16vh;
  left: 0;
  width: 34%;
  height: 58vh;
  margin: 1vh;

  .box_1 {
    display: flex;
    height: 18vh;

    .box_1_l {
      flex: 1;

      .l_2_content {
        display: flex;

        .content_txt {
          flex: 1;
          margin-top: 5%;
          text-align: center;

          span {
            font-weight: 700;
            font-size: calc(100vw * 80 / 1920);
          }
        }

        .content_img {
          flex: 2;
          height: 13.5vh;
          margin: 2%;
          background-color: #fff;

          div {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .box_1_l {
      flex: 1;
      position: relative;

      .box_1_l_txt {
        position: absolute;
        top: 22%;
        left: 4%;

        span {
          font-weight: 700;
          font-size: calc(100vw * 80 / 1920);
        }
      }

      .chart1 {
        width: 100%;
        height: 100%;
      }
    }
  }

  .box_2 {
    display: flex;
    margin-top: 1vh;
    height: 46vh;

    .box_2_l {
      flex: 1;

      .t_box {
        height: 19vh;
        position: relative;

        .box_2_l_txt {
          position: absolute;
          top: 20%;
          left: 5%;

          span {
            font-weight: 700;
            font-size: calc(100vw * 80 / 1920);
          }
        }

        .chart2 {
          width: 100%;
          height: 100%;
        }
      }

      .b_box {
        margin-top: 1vh;
        height: 26vh;

        /deep/ .el-table {
          margin: auto;
          padding: 0;
        }
        /deep/ .el-table tr,
        .el-table {
          background-color: rgba(255, 255, 255, 0);
        }

        /deep/ .cell {
          font-weight: 900;
        }

        /deep/ .el-table__cell {
          padding: 1vh 0;
          text-align: center;
        }

        // ----------修改elementui表格的默认样式-----------
        /deep/ .el-table__body-wrapper {
          &::-webkit-scrollbar {
            // 整个滚动条
            width: 0; // 纵向滚动条的宽度
            background: rgba(213, 215, 220, 0.3);
            border: none;
          }
          &::-webkit-scrollbar-track {
            // 滚动条轨道
            border: none;
          }
        }

        // --------------------隐藏table gutter列和内容区右侧的空白 start
        /deep/ .el-table th.gutter {
          display: none;
          width: 0;
        }
        .el-table colgroup col[name="gutter"] {
          display: none;
          width: 0;
        }

        /deep/ .el-table__body {
          width: 100% !important;
        }

        // --------------------隐藏table gutter列和内容区右侧的空白 end
      }
    }

    .box_2_r {
      margin-left: 1%;
      flex: 1;

      .box_2_t {
        height: 21vh;

        /deep/ .el-table {
          margin: auto;
          padding: 0;
        }
        /deep/ .el-table tr,
        .el-table {
          background-color: rgba(255, 255, 255, 0);
        }

        /deep/ .cell {
          font-weight: 900;
        }

        /deep/ .el-table__cell {
          padding: 1vh 0;
          text-align: center;
        }

        // ----------修改elementui表格的默认样式-----------
        /deep/ .el-table__body-wrapper {
          &::-webkit-scrollbar {
            // 整个滚动条
            width: 0; // 纵向滚动条的宽度
            background: rgba(213, 215, 220, 0.3);
            border: none;
          }
          &::-webkit-scrollbar-track {
            // 滚动条轨道
            border: none;
          }
        }

        // --------------------隐藏table gutter列和内容区右侧的空白 start
        /deep/ .el-table th.gutter {
          display: none;
          width: 0;
        }
        .el-table colgroup col[name="gutter"] {
          display: none;
          width: 0;
        }

        /deep/ .el-table__body {
          width: 100% !important;
        }

        // --------------------隐藏table gutter列和内容区右侧的空白 end
      }

      .box_2_b {
        height: 44%;
        margin: 2%;
        background-color: #fff;

        div {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>